const fonts = {
  inter: "Inter",
  ibm: "IBM Plex Mono",
};

export default fonts;
